function customDebounce(callback, delay = 250) {
  let timer;

  return function () {
    clearTimeout(timer);
    timer = setTimeout(callback, delay);
  };
}

const splideInstances = [];

function mountSplide(el, options, extensions) {
  const splide = new Splide(el, options);

  if (extensions) {
    splide.mount(extensions);
  } else {
    splide.mount();
  }

  splideInstances.push(splide);

  return splide;
}

window.addEventListener(
  "resize",
  customDebounce(() => {
    splideInstances.forEach((splide) => {
      if (splide && typeof splide.refresh === "function") {
        splide.refresh();
      }
    });
  })
);

document.addEventListener("DOMContentLoaded", function () {
  let started = false;
  let slider = null;

  function formatNumber(num) {
    return num.toLocaleString();
  }

  function animateCounter(counter) {
    const target = +counter.getAttribute("data-target");
    const prefix = counter.getAttribute("data-prefix") || "";
    const suffix = counter.getAttribute("data-suffix") || "";
    const duration = 2000;
    const startTime = performance.now();

    function update(currentTime) {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const value = Math.floor(progress * target);

      counter.textContent = prefix + formatNumber(value) + suffix;

      if (progress < 1) {
        requestAnimationFrame(update);
      } else {
        counter.textContent = prefix + formatNumber(target) + suffix;
      }
    }

    requestAnimationFrame(update);
  }

  function startCounters() {
    if (started) return;
    counters.forEach((counter) => animateCounter(counter));
    started = true;
  }

  function loadSlides(tabIndex) {
    const list = document.querySelector(".js-featured-slides");
    const template = document.querySelector(`template[data-tab="${tabIndex}"]`);

    if (!template || !list) return;

    list.innerHTML = template.innerHTML;

    if (slider) {
      slider.refresh();
    }
  }

  const threeColumnEl = document.querySelectorAll(".js-three-column-splide");
  if (threeColumnEl.length > 0) {
    threeColumnEl.forEach(function (el) {
      mountSplide(el, {
        mediaQuery: "min",
        arrows: false,
        pagination: false,
        autoplay: true,
        interval: 3000,
        type: "loop",
        drag: false,
        pauseOnHover: false,
        breakpoints: {
          768: { destroy: true },
        },
      });
    });
  }

  const logoCarouselEl = document.querySelectorAll(".js-logo-carousel-splide");
  if (logoCarouselEl.length > 0) {
    logoCarouselEl.forEach(function (el) {
      mountSplide(
        el,
        {
          mediaQuery: "min",
          perPage: 2,
          arrows: false,
          pagination: false,
          pauseOnHover: false,
          type: "loop",
          drag: false,
          autoScroll: {
            speed: 0.5,
          },
          breakpoints: {
            768: {
              perPage: 3,
            },
            1024: {
              perPage: 4,
            },
            1440: {
              perPage: 5,
            },
          },
        },
        window.splide.Extensions
      );
    });
  }

  const cardCarouselEl = document.querySelectorAll(".js-cards-splide");
  if (cardCarouselEl.length > 0) {
    cardCarouselEl.forEach(function (el) {
      mountSplide(el, {
        type: "loop",
        mediaQuery: "min",
        arrows: true,
        pagination: true,
        gap: "2rem",
        perPage: 1,
        breakpoints: {
          768: {
            perPage: 1,
            padding: {
              right: "30%",
            },
          },
          1280: {
            perPage: 2,
            padding: {
              right: "7%",
            },
          },
        },
      });
    });
  }

  const counters = document.querySelectorAll(".counter");
  if (counters.length > 0) {
    const section = document.querySelector(".js-counter-custom");

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          startCounters();
        }
      },
      { threshold: 0.5 }
    );

    observer.observe(section);
  }

  const starRating = document.querySelectorAll(".star-rating");
  if (starRating.length > 0) {
    starRating.forEach((container) => {
      const rating = parseFloat(container.dataset.rating) || 0;

      for (let i = 1; i <= 5; i++) {
        const star = document.createElement("div");
        star.className = "star";

        const inner = document.createElement("div");
        inner.className = "star-inner";

        const fill = Math.max(0, Math.min(1, rating - (i - 1))) * 100;
        inner.style.width = fill + "%";

        star.appendChild(inner);
        container.appendChild(star);
      }
    });
  }

  const testimonialCarouselEl = document.querySelectorAll(".js-testimonial-custom-splide");
  if (testimonialCarouselEl.length > 0) {
    testimonialCarouselEl.forEach(function (el) {
      mountSplide(
        el,
        {
          mediaQuery: "min",
          perPage: 1,
          arrows: true,
          pagination: false,
          pauseOnHover: false,
          type: "loop",
          drag: false,
          gap: "1.8rem",
          autoScroll: {
            speed: 0.5,
          },
          breakpoints: {
            768: {
              perPage: 2,
            },
            1024: {
              perPage: 3,
            },
            1440: {
              perPage: 4,
            },
            1920: {
              perPage: 5,
            },
          },
        },
        window.splide.Extensions
      );
    });
  }

  // Always load the first configured collection.
  loadSlides(1);

  /*
  const tabs = document.querySelectorAll(".featured-cards__tab");

  if (tabs.length > 0) {
    tabs.forEach((tab) => {
      tab.addEventListener("click", () => {
        tabs.forEach((t) => t.classList.remove("is-active"));
        tab.classList.add("is-active");

        const tabIndex = tab.dataset.tab;

        loadSlides(tabIndex);
      });
    });
  }
  */

  const featuredCollectionEl = document.querySelector(".js-featured-splide");
  if (featuredCollectionEl) {
    slider = mountSplide(featuredCollectionEl, {
      mediaQuery: "min",
      arrows: true,
      pagination: true,
      gap: "2rem",
      perPage: 1,
      breakpoints: {
        768: {
          perPage: 1,
          padding: {
            right: "30%",
          },
        },
        1280: {
          perPage: 2,
          padding: {
            right: "7%",
          },
        },
      },
    });
  }

  const linksCarouselEl = document.querySelectorAll(".js-links-carousel-splide");
  if (linksCarouselEl.length > 0) {
    linksCarouselEl.forEach(function (el) {
      mountSplide(el, {
        mediaQuery: "min",
        perPage: 1,
        arrows: true,
        pagination: false,
        perMove: 1,
        pauseOnHover: false,
        type: "loop",
        drag: false,
        speed: 1000,
        gap: "2rem",
        breakpoints: {
          768: {
            perPage: 2,
            autoWidth: true,
          },
          1024: {
            perPage: 3,
          },
          1440: {
            perPage: 4,
          },
          1920: {
            perPage: 5,
          },
        },
      });
    });
  }

  const announcementCloseBtn = document.querySelector(".js-announcement-bar-close");
  if (announcementCloseBtn) {
    announcementCloseBtn.addEventListener("click", function (e) {
      e.preventDefault();
      const announcementBar = document.querySelector(".announcement-bar-section");
      announcementBar.style.display = "none";
    });
  }
});

document.addEventListener("DOMContentLoaded", () => {
  initFaqAccordions();

  const desktopQuery = window.matchMedia("(min-width: 1024px)");

  document.querySelectorAll(".accordion-slider__container").forEach((section) => {
    const accordion = section.querySelector(".accordion");
    if (!accordion) return;

    const items = [...accordion.querySelectorAll("details")];
    const duration = 6000;
    const accordionAnimationDuration = 350;

    let index = items.findIndex((d) => d.open);
    if (index === -1) index = 0;

    let timer;
    let timerStartDelay;
    let remaining = duration;
    let startTime;
    let isSectionVisible = false;

    const accordionImageSplide = section.querySelector(".js-accordion-slider-splide");

    const splide = mountSplide(accordionImageSplide, {
      mediaQuery: "min",
      arrows: false,
      pagination: false,
      gap: "2rem",
      perPage: 1,
      drag: false,
      speed: 600,
    });

    function resetBars() {
      items.forEach((item) => {
        const bar = item.querySelector(".bar");
        if (!bar) return;
        bar.style.transition = "none";
        bar.style.width = "0%";
      });
    }

    function startBar(i) {
      if (!desktopQuery.matches || !isSectionVisible) return;
      clearTimeout(timer);
      clearTimeout(timerStartDelay);

      remaining = duration;

      resetBars();

      const bar = items[i].querySelector(".bar");
      if (!bar) return;

      startTime = Date.now();

      requestAnimationFrame(() => {
        bar.style.transition = `width ${remaining}ms linear`;
        bar.style.width = "100%";
      });

      timer = setTimeout(next, remaining);
    }

    function startBarAfterAnimation(i) {
      clearTimeout(timer);
      clearTimeout(timerStartDelay);
      resetBars();
      if (!desktopQuery.matches || !isSectionVisible) return;

      timerStartDelay = setTimeout(() => {
        if (i === index) startBar(i);
      }, accordionAnimationDuration);
    }

    function pauseBar() {
      clearTimeout(timer);
      clearTimeout(timerStartDelay);

      const bar = items[index]?.querySelector(".bar");
      if (!bar || !startTime) return;

      const elapsed = Date.now() - startTime;
      remaining = Math.max(0, remaining - elapsed);
      bar.style.transition = "none";
      bar.style.width = getComputedStyle(bar).width;
    }

    function resumeBar() {
      if (!desktopQuery.matches || !isSectionVisible) return;

      const bar = items[index]?.querySelector(".bar");
      if (!bar) return;

      startTime = Date.now();
      requestAnimationFrame(() => {
        bar.style.transition = `width ${remaining}ms linear`;
        bar.style.width = "100%";
      });

      timer = setTimeout(next, remaining);
    }

    function expand(details) {
      const content = details.querySelector(".content");
      if (!content) return;

      details.open = true;
      content.style.height = "0px";

      requestAnimationFrame(() => {
        content.style.height = content.scrollHeight + "px";
      });

      setTimeout(() => {
        content.style.height = "auto";
      }, accordionAnimationDuration);
    }

    function collapse(details) {
      const content = details.querySelector(".content");
      if (!content) return;

      content.style.height = content.scrollHeight + "px";

      requestAnimationFrame(() => {
        content.style.height = "0px";
      });

      setTimeout(() => {
        details.open = false;
      }, accordionAnimationDuration);
    }

    function openAccordion(i, fromSlider = false) {
      items.forEach((item, idx) => {
        if (idx === i) {
          expand(item);
        } else if (item.open) {
          collapse(item);
        }
      });

      index = i;
      startBarAfterAnimation(i);

      if (!fromSlider) {
        splide.go(i);
      }
    }

    function next() {
      index = (index + 1) % items.length;
      openAccordion(index);
    }

    items.forEach((details, i) => {
      const summary = details.querySelector("summary");

      summary.addEventListener("click", (e) => {
        e.preventDefault();
        openAccordion(i);
      });

      details.addEventListener("mouseenter", () => {
        if (i !== index) return;

        clearTimeout(timer);

        const bar = items[index].querySelector(".bar");
        if (!bar) return;

        const elapsed = Date.now() - startTime;
        remaining -= elapsed;

        const computedWidth = getComputedStyle(bar).width;

        bar.style.transition = "none";
        bar.style.width = computedWidth;
      });

      details.addEventListener("mouseleave", () => {
        if (i !== index) return;

        startBar(index);
      });
    });

    splide.on("move", (newIndex) => {
      openAccordion(newIndex, true);
    });

    const firstContent = items[index]?.querySelector(".content");
    if (firstContent) firstContent.style.height = "auto";

    splide.go(index);

    if ("IntersectionObserver" in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          const wasVisible = isSectionVisible;
          isSectionVisible = entry.isIntersecting;

          if (isSectionVisible && !wasVisible) {
            resumeBar();
          } else if (!isSectionVisible && wasVisible) {
            pauseBar();
          }
        },
        { threshold: 0.35 }
      );

      observer.observe(section);
    } else {
      isSectionVisible = true;
      startBar(index);
    }

    window.addEventListener(
      "resize",
      customDebounce(() => {
        splide.refresh();
        splide.go(index);
      })
    );
  });
});

function initFaqAccordions(root = document) {
  root.querySelectorAll(".faq-accordion__container .accordion-group")
  .forEach((group) => {
    if (group.dataset.faqAccordionInitialized === "true") return;

    group.dataset.faqAccordionInitialized = "true";

    const items = [...group.querySelectorAll(".accordion")];

    function setItemState(item, isOpen) {
      const header = item.querySelector(".accordion-header");
      const content = item.querySelector(".accordion-content");

      if (!header || !content) return;

      item.classList.toggle("active", isOpen);
      header.setAttribute("aria-expanded", isOpen.toString());

      if (isOpen) {
        // Set the exact content height so the CSS transition
        // can animate smoothly from 0px to the full height.
        content.style.maxHeight = `${content.scrollHeight}px`;
      } else {
        // Animate smoothly back to 0.
        content.style.maxHeight = "0px";
      }
    }

    items.forEach((item) => {
      const header = item.querySelector(".accordion-header");
      const content = item.querySelector(".accordion-content");

      if (!header || !content) return;

      // Initialize the accordion state without animation.
      if (item.classList.contains("active")) {
        content.style.maxHeight = `${content.scrollHeight}px`;
      } else {
        content.style.maxHeight = "0px";
      }

      header.addEventListener("click", () => {
        const shouldOpen = !item.classList.contains("active");

        items.forEach((otherItem) => {
          setItemState(
            otherItem,
            otherItem === item ? shouldOpen : false
          );
        });
      });
    });

    window.addEventListener(
      "resize",
      customDebounce(() => {
        items.forEach((item) => {
          if (!item.classList.contains("active")) return;

          const content = item.querySelector(".accordion-content");

          if (!content) return;

          // Recalculate height when the viewport changes.
          content.style.maxHeight = `${content.scrollHeight}px`;
        });
      })
    );
  });
}

document.addEventListener("shopify:section:load", (event) => {
  initFaqAccordions(event.target);
});

document.addEventListener("click", function (event) {
  const card = event.target.closest(".product-card__wrapper[data-card-url]");

  if (!card || event.target.closest("a, button, input, select, textarea, label")) return;

  window.location.href = card.dataset.cardUrl;
});

(function () {
  function hasActiveFilterInUrl() {
    const params = new URLSearchParams(window.location.search);

    for (const key of params.keys()) {
      if (key.startsWith('filter.')) {
        return true;
      }
    }

    return false;
  }

  function scrollToProducts() {
    if (!hasActiveFilterInUrl()) return;

    const target =
      document.querySelector('#custom-product-grid') ||
      document.querySelector('.collection-empty');

    if (!target) return;

    const headerOffset = 150;

    const targetTop =
      target.getBoundingClientRect().top +
      window.scrollY -
      headerOffset;

    window.scrollTo({
      top: targetTop,
      behavior: 'smooth'
    });
  }

  function initFilterAutoScroll() {
    setTimeout(scrollToProducts, 250);
  }

  if (document.readyState === 'complete') {
    initFilterAutoScroll();
  } else {
    window.addEventListener('load', initFilterAutoScroll);
  }
})();